import { SupportedChainId } from "src/constants/chainENV/chains.base";

export const PLP_STATS_API_URL = "https://api.pinnako.io/api";

const BACKEND_URLS = {
  default: "https://api.pinnako.io",

  [SupportedChainId.ARBITRUM]: "https://api.pinnako.io",
  [SupportedChainId.BSCMAINNET]: "https://api.pinnako.io",
  [SupportedChainId.ARB_TEST]: "https://api.pinnako.io",
  [SupportedChainId.BSCTEST]: "https://api.pinnako.io",
  [SupportedChainId.ZKMAINNET]: "https://api.pinnako.io",
  [SupportedChainId.ZKTEST]: "https://api.pinnako.io",
};

export function getServerBaseUrl(chainId: number) {
  if (!chainId) {
    throw new Error("chainId is not provided");
  }

  if (document.location.hostname.includes("deploy-preview")) {
    const fromLocalStorage = localStorage.getItem("SERVER_BASE_URL");
    if (fromLocalStorage) {
      return fromLocalStorage;
    }
  }

  return BACKEND_URLS[chainId] || BACKEND_URLS.default;
}

export function getServerUrl(chainId: number, path: string) {
  return `${getServerBaseUrl(chainId)}${path}`;
}
